import styled from 'styled-components';
import { media } from '../../styles/theme';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.lg};
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
`;

export const Cabecalho = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.espaco.md};

  h1 {
    font-size: ${({ theme }) => theme.fonte.h1};
    color: ${({ theme }) => theme.cores.ink};
  }

  p {
    margin-top: 2px;
    color: ${({ theme }) => theme.cores.inkSecondary};
  }

  ${media.mobile} {
    h1 {
      font-size: ${({ theme }) => theme.fonte.h2};
    }
  }
`;

export const Acoes = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.sm};
  flex: 1;
  justify-content: flex-end;

  ${media.mobile} {
    flex-basis: 100%;
    justify-content: stretch;
  }
`;
